const classes_map = {
  berserker: "berserker",
  destroyer: "destroyer",
  warlord: "warlord",
  holyknight: "paladin",
  berserker_female: "slayer",
  battle_master: "battlemaster",
  infighter: "infighter",
  force_master: "soulmaster",
  lance_master: "lancemaster",
  battle_master_male: "striker",
  hawk_eye: "hawkeye",
  devil_hunter: "devilhunter",
  blaster: "blaster",
  scouter: "scout",
  devil_hunter_female: "gunslinger",
  blade: "blades",
  demonic: "demonic",
  reaper: "reaper",
  soul_eater: "souleater",
  arcana: "arcana",
  summoner: "summoner",
  bard: "bard",
  elemental_master: "sorceress",
  yinyangshi: "artist",
  weather_artist: "aeromancer",

}

export default classes_map;
